/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentType extends models.AgentFieldsBase {
    getFixupPrototypeFunction() { return AgentType.fixupPrototype; }

    static newInstance(model: Partial<AgentType>): AgentType {
        let obj = Object.assign(new AgentType(), model);
        AgentType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentType>): AgentType {
        if (!model) return null;
        return AgentType.newInstance(<AgentType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentType) {
        if (!obj) return;

        models.AgentType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentType): boolean {
        if (models.AgentFieldsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AgentType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * AI agents available in the system
     */
    name: models.Agents;

    /**
     * Is the agent type enabled
     */
    is_enabled: boolean;

}
